import { AmountValueLocalized } from '@components'

import { SkeletonText as SkeletonTextComponent } from '@billy/design-system'
import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-right: 20px;
`

export const SkeletonText = styled(SkeletonTextComponent)`
  margin-bottom: 7px;
`

export const AmountValue = styled(AmountValueLocalized)`
  margin-bottom: 7px;
`

export const TextWrapper = styled.div`
  display: flex;
`
